<template>
	<main>
		<app-header />
		<app-banner />
		<form
			class="registration-form"
			id="RegistrationForm"
			@submit.stop.prevent="submit()"
		>
			<div class="form-col">
				<h3 class="text-center" v-html="cms.formHeadHtml"></h3>
				<header>Dane osobowe</header>
			</div>
			<div class="form-fields-col">
				<v-input
					id="FirstName"
					type="text"
					label="Imię"
					:errorMessage="firstNameErrorMsg"
					:modelValue="data.firstName"
					@update:modelValue="
						(newValue) => (data.firstName = newValue)
					"
				/>
				<v-input
					id="LastName"
					type="text"
					label="Nazwisko"
					:errorMessage="lastNameErrorMsg"
					:modelValue="data.lastName"
					@update:modelValue="
						(newValue) => (data.lastName = newValue)
					"
				/>
				<v-input
					id="Email"
					type="email"
					label="Adres e-mail"
					:errorMessage="emailErrorMsg"
					:modelValue="data.email"
					@update:modelValue="(newValue) => (data.email = newValue)"
				/>
				<v-input
					id="Phone"
					type="tel"
					label="Numer telefonu"
					:errorMessage="phoneErrorMsg"
					:modelValue="data.phone"
					@update:modelValue="(newValue) => (data.phone = newValue)"
				/>
			</div>
			<div class="form-col">
				<header>Zgody</header>
				<div class="agreement">
					<h6>{{ cms.formAgreementHead1 }}</h6>
					<p>
						<small v-html="cms.formAgreementHtml1"></small>
					</p>
					<div class="agreement-accept">
						<div class="custom-control custom-switch">
							<input
								v-model="data.agreement1"
								type="checkbox"
								class="custom-control-input"
								id="Agreement1"
							/>
							<label
								class="custom-control-label"
								for="Agreement1"
								>{{ cms.fomrAgreementCbx1 }}</label
							>
							<div
								v-for="(error, i) in agreement1ErrorMsg"
								:key="i"
							>
								<small class="d-block text-danger">{{
									error
								}}</small>
							</div>
						</div>
					</div>
				</div>
				<div class="agreement">
					<p style="margin-bottom: 5px"></p>
					<div class="agreement-accept">
						<div class="custom-control custom-switch">
							<input
								v-model="data.agreement2"
								type="checkbox"
								class="custom-control-input"
								id="Agreement2"
							/>
							<label
								class="custom-control-label"
								for="Agreement2"
								>{{ cms.fomrAgreementCbx2 }}</label
							>
							<div
								v-for="(error, i) in agreement2ErrorMsg"
								:key="i"
							>
								<small class="d-block text-danger">{{
									error
								}}</small>
							</div>
						</div>
					</div>
				</div>
				<div class="agreement">
					<p style="margin-bottom: 5px"></p>
					<div class="agreement-accept">
						<div class="custom-control custom-switch">
							<input
								v-model="data.agreement3"
								type="checkbox"
								class="custom-control-input"
								id="Agreement3"
							/>
							<label
								class="custom-control-label"
								for="Agreement3"
								>{{ cms.fomrAgreementCbx3 }}</label
							>
						</div>
					</div>
				</div>

				<div
					class="agreement"
					style="position: relative; margin-top: 12px"
				>
					<h6>{{ cms.formAgreementHead2 }}</h6>
					<!-- <p style="margin-bottom: 5px">
						<small v-html="cms.formAgreementHtml2"></small>
					</p> -->
					<p>
						<small v-html="cms.formAgreementHtml2"></small>
						<span
							style="cursor: pointer"
							@mouseenter="showTooltip = true"
							@click="showTooltip = true"
						>
							[…]
						</span>
					</p>

					<div
						v-if="showTooltip"
						id="RodoTooltip"
						class="tooltip"
						style="position: relative"
					>
						<div @click="showTooltip = false">
							<div class="close"></div>
						</div>
						<div style="text-align: left">
							<b>Zasady przetwarzania Twoich danych</b>
						</div>
						<div class="row" style="border: 1px solid grey">
							<div
								class="col-12 col-sm-4"
								style="border: 1px solid grey"
							>
								administrator danych osobowych
							</div>
							<div
								class="col-12 col-sm-8"
								style="border: 1px solid grey"
							>
								Administratorem Twoich danych osobowych jest
								mBank S.A. z siedzibą w Warszawie przy ul.
								Prostej 18 (Bank), prowadzący działalność
								maklerską w ramach wyodrębnionej jednostki
								organizacyjnej – Biura maklerskiego mBanku
								(mBm).
							</div>
						</div>
						<div class="row" style="border: 1px solid grey">
							<div
								class="col-12 col-sm-4"
								style="border: 1px solid grey"
							>
								podstawa podania danych i cel ich przetwarzania
							</div>
							<div
								class="col-12 col-sm-8"
								style="border: 1px solid grey"
							>
								Będziemy przetwarzać Twoje dane osobowe:
								<ul>
									<li>
										• przesyłać Ci materiały marketingowe
										usług i produktów własnych Banku oraz
										mBm;
									</li>
									<li>
										• udostępnić demonstracyjny rachunek
										inwestycyjny mForex Trader,
									</li>
									<li>
										• na potrzeby prowadzonej działalności,
										w tym w celach:
										<ul>
											<li>
												• statystycznych i
												analitycznych,
											</li>
											<li>• obsługi reklamacji,</li>
											<li>• archiwizacji.</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
						<div class="row">
							<div
								class="col-12 col-sm-4"
								style="border: 1px solid grey"
							>
								komu przekazujemy Twoje dane
							</div>
							<div
								class="col-12 col-sm-8"
								style="border: 1px solid white"
							>
								Nie będziemy przekazywać dotyczących Cię danych
								innym podmiotom.
							</div>
						</div>
						<div class="row" style="border: 1px solid grey">
							<div
								class="col-12 col-sm-4"
								style="border: 1px solid grey"
							>
								okres przetwarzania danych
							</div>
							<div
								class="col-12 col-sm-8"
								style="border: 1px solid grey"
							>
								Twoje dane będziemy przetwarzać nie dłużej niż 5
								lat liczonych od momentu:<br />
								- wygaśnięcia dostępu do platformy demo mForex
								Trader. <br />
								Po upływie tego okresu zanonimizujemy te dane.
							</div>
						</div>
						<div
							class="row"
							style="
								text-align: left;
								border-left: 2px solid grey;
								border-right: 2px solid grey;
							"
						>
							<b
								style="
									padding-left: 16px;
									padding-top: 6px;
									padding-bottom: 6px;
								"
								>Twoje uprawnienia</b
							>
						</div>
						<div class="row" style="border: 1px solid grey">
							<div
								class="col-12 col-sm-4"
								style="border: 1px solid grey"
							>
								Prawa dotyczące przetwarzanych danych
							</div>
							<div
								class="col-12 col-sm-8"
								style="border: 1px solid grey"
							>
								<ol>
									<li>
										Za pośrednictwem zakładki "Kontakt" na
										stronie internetowej www.mforex.pl:
										<ul>
											<li>
												• masz prawo do dostępu i
												sprostowania swoich danych oraz
												ich przeniesienia,
											</li>
											<li>
												• możesz żądać ich usunięcia,
												ograniczenia lub wnieść sprzeciw
												wobec ich przetwarzania.
											</li>
										</ul>
									</li>
									<li>
										Masz również prawo wnieść skargę do
										organu nadzorczego w zakresie ochrony
										Twoich danych.
									</li>
								</ol>
							</div>
						</div>
						<div class="row" style="border: 1px solid grey">
							<div
								class="col-12 col-sm-4"
								style="border: 1px solid grey"
							>
								Twoje zgody i Pakiet RODO
							</div>
							<div
								class="col-12 col-sm-8"
								style="border: 1px solid grey"
							>
								Wszystkie zgody możesz zmienić lub odwołać za
								pośrednictwem zakładki "Kontakt" na stronie
								internetowej www.mforex.pl. Przetwarzanie
								danych, które wykonaliśmy przed wycofaniem
								zgody, jest zgodne z prawem. Więcej informacji
								na temat zasad przetwarzania danych, w tym
								Twoich uprawnień, znajdziesz w Pakiecie RODO i
								na stronie

								<a
									href="https://www.mforex.pl/regulaminy"
									target="_blank"
									rel="noreferrer nofollow noopener"
								>
									https://www.mforex.pl/regulaminy</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="form-fields-col mb-5 mt-4">
				<app-captcha
					id="Captcha"
					type="text"
					label="Przepisz słowo z obrazka"
					:modelValue="data.captchaValue"
					@update:modelValue="
						(newValue) => (data.captchaValue = newValue)
					"
					:errorMessage="captchaErrorMsg"
					:captchaImageUrl="captchaImageUrl"
					@reloadCaptcha="loadCaptchaImage()"
				/>
			</div>
			<div class="form-col">
				<div class="text-center">
					<button
						:disabled="isPosting"
						type="submit"
						class="btn btn-primary"
					>
						Załóż konto Demo
					</button>
					<div style="height: 49px">
						<p v-if="isPosting" class="text-danger">
							Trwa zakładanie rachunku demo
						</p>
					</div>
				</div>
				<a
					:href="cms.formEnrironmentLink"
					class="form-link"
					target="_blank"
				>
					<img src="images/icons/document.png" alt="ikona" />
					{{ cms.formEnrironmentTxt }}
				</a>
				<div class="disclaimer">
					<p class="d-md-none">
						<b>Nota prawna:</b>
					</p>
					<p>
						{{ cms.footerText1 }}
						<b>{{ cms.footerText2 }}</b>
						{{ cms.footerText3 }}
					</p>
				</div>
			</div>
		</form>
	</main>
</template>

<script>
import AppHeader from '@/components/AppHeader';
import AppBanner from '@/components/AppBanner';
import AppCaptcha from '@/components/AppCaptcha';
import { mapGetters, mapMutations } from 'vuex';
import axios from 'axios';

export default {
	data() {
		return {
			showTooltip: false,
			/* eslint-disable */
			cms: {
				bannerRegButton: BANNER_REG_BUTTON,
				formHeadHtml: FORM_HEAD_HTML,
				formAgreementHead1: FORM_AGREEMENT_1_HEAD,
				formAgreementHtml1: FORM_AGREEMENT_1_HTML,
				fomrAgreementCbx1: FORM_AGREEMENT_1_CBX,
				formAgreementHead2: FORM_AGREEMENT_2_HEAD,
				formAgreementHtml2: FORM_AGREEMENT_2_HTML,
				fomrAgreementCbx2: FORM_AGREEMENT_2_CBX,
				fomrAgreementCbx3: FORM_AGREEMENT_3_CBX,
				formEnrironmentLink: FORM_ENVIRONMENT_LINK,
				formEnrironmentTxt: FROM_ENVIRONMENT_TXT,
				footerText1: FOOTER_TXT1,
				footerText2: FOOTER_TXT2,
				footerText3: FOOTER_TXT3,
			},
			/* eslint-enable */
			data: {
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
				agreement1: false,
				agreement2: false,
				agreement3: false,
				refId: null,
				leadTypeId: CONFIG_LEAD_TYPE_ID, // eslint-disable-line
				captchaValue: '',
				gclid: '',
			},

			captchaImageUrl: '',
			firstNameErrorMsg: [],
			lastNameErrorMsg: [],
			emailErrorMsg: [],
			phoneErrorMsg: [],
			agreement1ErrorMsg: [],
			captchaErrorMsg: [],
			agreement2ErrorMsg: [],
			filedsWithError: [],
		};
	},
	components: {
		AppHeader,
		AppBanner,
		AppCaptcha,
	},
	methods: {
		...mapMutations(['setIsPosting']),

		validateEmail(email) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (emailRegex.test(email)) {
				const atIndex = email.indexOf('@');
				if (email.indexOf('@', atIndex + 1) === -1) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},

		validatePhoneNumber(phoneNumber) {
			const digitsOnlyRegex = /^\d+$/;
			if (!digitsOnlyRegex.test(phoneNumber)) {
				return false;
			}
			if (phoneNumber.length >= 9 && phoneNumber.length <= 15) {
				return true;
			} else {
				return false;
			}
		},

		validator(field, message, scrollToId) {
			let fieldErrorMsg;

			if (!field) {
				fieldErrorMsg = [message];
				this.filedsWithError.push(scrollToId);
			} else {
				fieldErrorMsg = [];
			}

			return fieldErrorMsg;
		},
		submit() {
			this.filedsWithError = [];
			this.firstNameErrorMsg = this.validator(
				this.data.firstName,
				'Imię jest wymagane!',
				'FirstName'
			);
			this.lastNameErrorMsg = this.validator(
				this.data.lastName,
				'Nazwisko jest wymagane!',
				'LastName'
			);
			this.emailErrorMsg = this.validator(
				this.data.email,
				'Adres e-mail jest wymagany!',
				'Email'
			);

			// Dodatkowa walidacja na email
			if (!this.validateEmail(this.data.email)) {
				this.emailErrorMsg.push('Błędny adres email');
				this.filedsWithError.push('Email');
			}

			this.phoneErrorMsg = this.validator(
				this.data.phone,
				'Numer telefonu jest wymagany!',
				'Phone'
			);

			// Dodatkowa walidacja na telefon
			if (!this.validatePhoneNumber(this.data.phone)) {
				this.phoneErrorMsg.push(
					'Numeru telefonu powinien składać się z samych cyfr a jego długość powinna być od 9 do 15 znaków'
				);
				this.filedsWithError.push('Phone');
			}

			this.agreement1ErrorMsg = this.validator(
				this.data.agreement1,
				'Zgoda na email jest wymagana!',
				'Agreement1'
			);
			this.agreement2ErrorMsg = this.validator(
				this.data.agreement2,
				'Zgoda na kontakt telefoniczny jest wymagana!',
				'Agreement2'
			);

			this.captchaErrorMsg = this.validator(
				this.data.captchaValue,
				'Przepisz słowo z obrazka!',
				'Captcha'
			);

			if (this.filedsWithError.length > 0) {
				let firstError = this.filedsWithError[0];
				if (
					document.getElementById(firstError).getBoundingClientRect()
						.top < 30
				) {
					document
						.getElementById(firstError)
						.scrollIntoView({ behavior: 'smooth' }, true);
				}
			} else {
				const headers = {
					'Authorization': 'Token ' + CONFIG_API_TOKEN, // eslint-disable-line
					'Content-Type': 'application/x-www-form-urlencoded',
				};

				let formData = new FormData();

				Object.entries(this.data).forEach(([key, value]) => {
					formData.append(key, value);
				});

				this.setIsPosting(true);
				axios
					.post('Register', formData, {
						headers,
					})
					.then(
						() => {
							this.handlingSuccess();
						},
						(response) => {
							this.handlingErrror(response);
						}
					)
					.then(() => {
						this.loadCaptchaImage();
					});
			}
		},
		handlingSuccess() {
			this.filedsWithError = [];
			this.firstNameErrorMsg = [];
			this.lastNameErrorMsg = [];
			this.emailErrorMsg = [];
			this.phoneErrorMsg = [];
			this.agreement1ErrorMsg = [];
			this.captchaErrorMsg = [];
			this.setIsPosting(false);
			this.agreement2ErrorMsg = [];
			this.$router.push('/Success');
		},
		handlingErrror(response) {
			this.filedsWithError = [];
			this.setIsPosting(false);
			this.loadCaptchaImage();

			if (response.response.status === 400) {
				let errors = response.response.data.errors;

				if (errors['FirstName']) {
					this.firstNameErrorMsg = errors['FirstName'];
					this.filedsWithError.push('FirstName');
				}

				if (errors['LastName']) {
					this.lastNameErrorMsg = errors['LastName'];
					this.filedsWithError.push('LastName');
				}

				if (errors['Email']) {
					this.emailErrorMsg = errors['Email'];
					this.filedsWithError.push('Email');
				}

				if (errors['Phone']) {
					this.phoneErrorMsg = errors['Phone'];
					this.filedsWithError.push('Phone');
				}

				if (errors['Agreement1']) {
					this.agreement1ErrorMsg = errors['Agreement1'];
					this.filedsWithError.push('Agreement1');
				}
				if (errors['Agreement2']) {
					this.agreement2ErrorMsg = errors['Agreement2'];
					this.filedsWithError.push('Agreement2');
				}

				if (errors['captchaValue']) {
					this.captchaErrorMsg = errors['captchaValue'];
					this.filedsWithError.push('Captcha');
				}

				document
					.getElementById(this.filedsWithError[0])
					.scrollIntoView({ behavior: 'smooth' }, true);
			} else {
				this.$router.push('/Error');
			}
		},
		setRefId() {
			let fullPath = this.$route.fullPath;
			var cookieValue = this.$cookies.get('DBre_Refid_D');
			if (cookieValue != null && cookieValue.length) {
				this.data.refId = cookieValue;
			} else {
				if (fullPath !== '/' || fullPath.length > 1) {
					this.data.refId = fullPath.replace('/', '');
				}
			}
		},
		loadCaptchaImage() {
			const headers = {
				Authorization: 'Token ' + CONFIG_API_TOKEN, // eslint-disable-line
			};
			axios
				.get('ShowCaptcha', {
					headers,
				})
				.then((response) => {
					this.captchaImageUrl =
						'data:image/png;base64,' + response.data;
					this.data.captchaValue = '';
				})
				.catch(function () {});
		},
		isMvcCookie() {
			let c = this.getMvcCookie();
			return c ? c : false;
		},
		getMvcCookie() {
			return this.$cookies.get('.AspNetCore.Session');
		},
	},
	mounted() {
		this.setRefId();
		this.loadCaptchaImage();
		if (this.$route.query.gclid) {
			this.data.gclid = this.$route.query.gclid;
		}
	},
	computed: {
		...mapGetters(['windowWidth', 'mobileBreakpoint', 'isPosting']),
	},
};
</script>
